import React from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { Button, EmptyState } from 'shared/ui'
import broadcastsPreviewImg from 'shared/assets/images/broadcasts/broadcasts_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import { LINK_BROADCAST_HELP_GUIDE } from 'shared/constants/links'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import styles from './styles.module.scss'

export const EmptyStateBroadcasts = observer(() => {
  const navigate = useNavigate()
  const onClick = () => {
    navigate(`/${BroadcastsRoutes.root}/${BroadcastsRoutes.create}`)
  }

  return (
    <EmptyState
      variant={'preview'}
      previewImg={<img alt='Broadcasts preview' src={getCDNAssetURL(broadcastsPreviewImg)} />}
      title={'Create your first broadcast'}
      subtitle={'Send mass message to drive sales or for reminders'}
      actions={
        <>
          <Button
            text={'New broadcast'}
            onClick={onClick}
            iconProps={{ icon: 'add' }}
            size={'medium'}
          />
          <Button
            tag='a'
            text='Help guide'
            size='medium'
            contained='secondary'
            iconProps={{ icon: 'info' }}
            className={styles.helpButton}
            href={LINK_BROADCAST_HELP_GUIDE}
            target='_blank'
            rel='noreferrer'
          />
        </>
      }
    />
  )
})
